<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Outstanding Fees Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-combobox v-model="registration_no" :loading="comp_load" rounded :items="stud_list"
                        label="Select Student" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"
                        @click="clearselection"></v-combobox>
                </v-col>
                <v-btn class="button mt-4" v-if="registration_no != null" @click="getReport()">Proceed</v-btn>
            </v-row>
            <span v-if="learner_info!=null">
                <v-col sm="2">
                    <!-- <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn> -->
                    <v-btn rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'OutStandingFeeReport')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Quota</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="">Mobile No.</th>
                                    <th class="" v-for="header in ay_header" :key="header">
                                        <center>{{ header }}</center>
                                    </th>
                                    <th class="">Total Outstanding</th>
                                    <th class="">Paid Outstanding</th>
                                    <th class="">Remaining Outstanding</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="(s,index) in learner_info" :key="s.s_id">
                                    <td>{{index+1}}</td>
                                    <td>{{s.reg_no}}</td>
                                    <td>{{s.name}}</td>
                                    <td>{{s.quota}}</td>
                                    <td>{{s.leaner_std}}</td>
                                    <td>{{s.leaner_div}}</td>
                                    <td>{{s.primary_contact_number}}</td>
                                    <td v-for="header in s.out_amt" :key="header">
                                        {{header}}
                                    </td>
                                    <td>{{all_total_amount}}</td>
                                    <td>{{all_total_paid}}</td>
                                    <td>{{all_total_remaining}}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </div>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                comp_load: false,
                fetch_loader: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                com_sub_loader: false,
                overlay: false,
                selected: [],
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                registration_no:null,
                learner_info:null,
                ay_header:null,
                all_total_amount:null,
                all_total_paid:null,
                all_total_remaining:null,
            };
        },
        methods: {
             clearselection() {
                (this.learner_info = null);
            },
            // ExportToExcel(){
            //     var htmltable= document.getElementById('my-table-id');
            //     var html = htmltable.outerHTML;
            //     window.open('data:application/vnd.ms-excel,' + encodeURIComponent(html));
            // },
            fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Registration No.</th>
      <th>Name</th>
      <th>Quota</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Mobile No.</th>
      <th>Total Outstanding</th>
      <th>Paid Outstanding</th>
      <th>Remaining Outstanding</th>
    </tr>`;

  this.learner_info.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${item.reg_no}</td>
        <td>${item.name}</td>
        <td>${item.quota}</td>
        <td>${item.leaner_std}</td>
        <td>${item.leaner_div}</td>
        <td>${item.primary_contact_number}</td>
        <td>${this.all_total_amount}</td>
        <td>${this.all_total_paid}</td>
        <td>${this.all_total_remaining}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload(){
                this.comp_load = true;
                axios
                .post("/admission/getAllStudents_for_account")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
            },
            getReport() {
                this.overlay = true;
                const data = {
                    child: this.registration_no.registration_number,
                };
                axios
                    .post("/OutstandingFees/getOutstandingFeesReportAllAY", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_info = res.data.learner_info
                            this.ay_header = res.data.ay_header 
                            this.all_total_amount = res.data.all_total_amount
                            this.all_total_paid = res.data.all_total_paid
                            this.all_total_remaining = res.data.all_total_remaining
                        }
                         else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                        this.overlay = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
 .scroll {
        overflow-x: scroll;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
     tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
